<div class="row mb-3">
  <div class="col-md-12 d-flex justify-content-between align-items-center">
    <h3 class="mb-0">Driver Load Search Details</h3>

    <button type="button" class="btn btn-primary" (click)="backToList()">
      <i class="fa fa-arrow-left mr-1"></i>
      Back
    </button>
  </div>
</div>

<!-- Loading -->

<div *ngIf="loading" class="text-center mt-5 mb-5">
  <i class="fa fa-spinner fa-spin fa-2x"></i>

  <div class="mt-2">Loading...</div>
</div>

<!-- Details -->

<div *ngIf="!loading && searchDetails" class="row">
  <!-- Driver Details -->

  <div class="col-md-6">
    <div class="main-card mb-3 card">
      <div
        class="card-header d-flex justify-content-between align-items-center font-weight-bold fs-1r"
      >
        <span> Driver Details </span>
      </div>

      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Name</div>

          <div class="col-md-8">
            {{ searchDetails.driver?.name || "-" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Mobile</div>

          <div class="col-md-8">
            {{ searchDetails.driver?.mobile || "-" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Email</div>

          <div class="col-md-8">
            {{ searchDetails.driver?.email || "-" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Driver ID</div>

          <div class="col-md-8">
            {{ searchDetails.driverId || "-" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search Details -->

  <div class="col-md-6">
    <div class="main-card mb-3 card">
      <div
        class="card-header d-flex justify-content-between align-items-center font-weight-bold fs-1r"
      >
        <span> Search Details </span>
      </div>

      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">From City</div>

          <div class="col-md-8">
            <i class="fa fa-map-marker text-success mr-1"></i>

            {{ searchDetails.search?.pickupLocationCity || "-" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">To City</div>

          <div class="col-md-8">
            <i class="fa fa-map-marker text-danger mr-1"></i>

            {{ searchDetails.search?.dropLocationCity || "-" }}
          </div>
        </div>

        <!-- <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Search Type</div>

          <div class="col-md-8">
            <span class="badge badge-success" *ngIf="searchDetails.searchType">
              {{ searchDetails.searchType }}
            </span>

            <span *ngIf="!searchDetails.searchType"> - </span>
          </div>
        </div> -->

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Searched On</div>

          <div class="col-md-8">
            {{
              searchDetails.createdAt | date: "dd MMM yyyy hh:mm a" : "en-IN"
            }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search Information -->

  <div class="col-md-12">
    <div class="main-card mb-3 card">
      <div class="card-header font-weight-bold fs-1r">Search Information</div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="font-weight-bold">Search History ID</div>

            <div class="text-muted">
              {{ searchDetails._id || "-" }}
            </div>
          </div>

          <div class="col-md-6">
            <div class="font-weight-bold">Created At</div>

            <div class="text-muted">
              {{
                searchDetails.createdAt
                  | date: "dd MMM yyyy hh:mm:ss a" : "en-IN"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- No Data -->

<div *ngIf="!loading && !searchDetails" class="main-card mb-3 card">
  <div class="card-body text-center">
    <div class="text-danger mt-5 mb-5">Search history details not found.</div>

    <button type="button" class="btn btn-secondary" (click)="backToList()">
      <i class="fa fa-arrow-left mr-1"></i>
      Back to List
    </button>
  </div>
</div>
